import { Injectable } from "@angular/core";
import { AppState } from "@core/store";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import * as LandingAction from "../store/actions/landing.action";

@Injectable()
export class LandingFacade {
  constructor(private store: Store<AppState>) {}

  public getEraseData$: Observable<number> = this.store.select(s => s.landing.eraseData);

  public sendLead(businessType: string, email: string, name: string, orderEstimate: string, phone: string) {
    this.store.dispatch(LandingAction.sendLead({ businessType, email, name, orderEstimate, phone }));
  }

  public eraseData() {
    this.store.dispatch(LandingAction.eraseData());
  }
}
